"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : INCONTENT MESSAGE : STYLES --------------- ++++++++++ */


var _default = {
  incontentmessage: {
    display: 'flex',
    flexDirection: 'column',
    padding: (0, _index.replacePXinStringWithEM)("20px ".concat(_index.theme.spacing.sides, " 0px")),
    // padding: props => props.padding ? replacePXinStringWithEM(`${props.padding}px ${theme.spacing.sides} 0px`) : 'none',
    // named messages
    '& .message.name-reportingdelay': {
      order: '-1' // make this first message

    },
    // animation
    '& .message': {
      opacity: '0',
      animationName: 'fadeInUp',
      animationDuration: '.2s',
      animationFillMode: 'forwards',
      extend: (0, _index.nthChildIterator)(10, .3, .05)
    }
  }
};
exports.default = _default;